<template>
  <v-dialog v-model="editDialog" class="the-app-dialogs" persistent max-width="600px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t('Edit Tax Information') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout row wrap>
            <v-flex xs12 pa-2 ma-2 white>
              Income Before Tax: <strong>{{ income.income_before_tax | currency }}</strong>
            </v-flex>
            <v-flex xs12 pa-2 ma-2 white>
              Tax Percentage: <strong>{{ income.tax_percentage }}%</strong>
            </v-flex>
            <v-flex xs12 pa-2 ma-2 white>
              Due Tax Amount: <strong>{{ income.due_tax_amount | currency }}</strong>
            </v-flex>
            <v-flex xs8 pa-2>
              <v-text-field
                v-model="taxInfo.tax_amount"
                :label="`${$t('Tax Amount')} (${systemCurrency}) *`"
                box
                hide-details
                background-color="white"
                :error="errors.has('tax_amount')"
                name="tax_amount"
                v-validate="'required|decimal:3|min_value:0'"
                data-vv-delay="1000"
              />
            </v-flex>

            <v-flex xs4 pa-2>
              <v-menu v-model="taxDateMenu" full-width max-width="290" :close-on-content-click="false">
                <v-text-field
                  slot="activator"
                  :value="taxInfo.tax_date"
                  :label="`${$t('Tax Date')} *`"
                  prepend-inner-icon="event"
                  box
                  readonly
                  hide-details
                  name="tax_date"
                  background-color="white"
                  autocomplete="off"
                  :error="errors.has('tax_date')"
                  v-validate="'required|date_format:yyyy-MM-dd'"
                />
                <v-date-picker @change="taxDateMenu = false" v-model="taxInfo.tax_date" />
              </v-menu>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnUpdateLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'edit-component',

  props: {
    editDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      btnUpdateLoading: false,
      taxDateMenu: false
    }
  },

  computed: {
    ...mapGetters({
      taxInfo: 'taxes/getTaxInfo',
      income: 'taxes/getIncome'
    })
  },

  watch: {
    editDialog: {
      immediate: false,
      handler() {
        if (this.editDialog) {
          this.addEscKeyListener()
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updateTaxInfo: 'taxes/updateTaxInfo'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the 'ESC' button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    validateBeforeSubmit(event) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnUpdateLoading = true
          let formData = new FormData(event.target)
          formData.append('net_income_before_tax', this.income.income_before_tax)

          let payload = { id: this.taxInfo.government_tax_id, formData }
          this.updateTaxInfo(payload)
            .then(() => {
              this.btnUpdateLoading = false
              this.$emit('updated')
            })
            .catch(() => {
              this.btnUpdateLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped />
